/**
 * @generated SignedSource<<b96d454c5ac0d6fc03275cba46b1ad82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptions_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerArrangeDelivery_item" | "BuyerLocalPickup_item" | "CheckoutShippingDetails_item">;
  readonly " $fragmentType": "CheckoutDeliveryOptions_item";
};
export type CheckoutDeliveryOptions_item$key = {
  readonly " $data"?: CheckoutDeliveryOptions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryOptions_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerLocalPickup_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerArrangeDelivery_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b00f9adf0e1c895c87885060245ea89e";

export default node;
